<template>
  <div class="container">
    <Header></Header>
    <Banners :banner="banner"></Banners>

    <CoreTechnology></CoreTechnology>
    <DataApplicationModel></DataApplicationModel>
    <BusinessProcesses></BusinessProcesses>

    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/components/Header"
  import Footer from "@/components/Footer"
  import Banners from "@/components/Banners"
  import CoreTechnology from "@/components/Technology_Services/CoreTechnology"
  import DataApplicationModel from "@/components/Technology_Services/DataApplicationModel"
  import BusinessProcesses from "@/components/Technology_Services/BusinessProcesses"

  export default {
    name: 'Technology_Services',
    data() {
      return {
        banner: require("@/assets/imgs/bg-banner-tec.png")
      }
    },
    components: {
      Header, Banners,Footer,CoreTechnology,DataApplicationModel,BusinessProcesses
    },
    created() {
      this.$store.commit('changeNavs', 'Technology_Services')
    }
  }
</script>

<style scoped>
  .container {
    min-width: 1350px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Technology_Services.vue